<template>
  <div v-if="edit || propertyCreation">
    <loading v-bind:active.sync="loading"></loading>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-md-2">
            <label for="streetNumber" class="label-margin">Street #</label>
            <input type="text" v-model="streetNumber" class="form-control">
          </div>
          <div class="col-md-4">
            <label for="streetName" class="label-margin">Street Name</label>
            <input type="text" v-model="streetName" class="form-control">
          </div>
          <div class="col-md-3">
            <label for="streetSuffix" class="label-margin">Street Ending (St, Ave, etc.)</label>
            <input type="text" v-model="streetSuffix" class="form-control">
          </div>
          <div class="col-md-3">
            <label for="streetDirection" class="label-margin">Street Direction (E, W, etc.)</label>
            <input type="text" v-model="streetDirection" class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="city" class="label-margin">City</label>
            <input type="text" v-model="city" class="form-control">
          </div>
          <div class="col-md-4">
            <label for="state" class="label-margin">State</label>
            <input type="text" v-model="state" class="form-control"><!-- TODO: Dropdown -->
          </div>
          <div class="col-md-4">
            <label for="zipCode" class="label-margin">Zip Code</label>
            <input type="text" v-model="zipCode" class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="county" class="label-margin">County</label>
            <input type="text" v-model="county" class="form-control">
          </div>
          <div class="col-md-4">
            <label for="parcelId" class="label-margin">Parcel ID</label>
            <input type="text" v-model="parcelId" class="form-control">
          </div>
          <div class="col-md-4">
            <label for="unitNumber" class="label-margin">Unit #</label>
            <input type="text" v-model="unitNumber" class="form-control">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="remarks" class="label-margin">Description</label>
        <textarea v-model="remarks" class="form-control" rows="8" placeholder="Tell us what you like about your home!"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="style" class="label-margin">Home Type</label>
        <select v-model="style" class="form-control">
          <option disabled value="">Select Type</option>
          <option v-for="homeType in homeTypes" v-bind:key="homeType.id">{{ homeType }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="beds" class="label-margin"><i class="fas fa-bed"></i>Beds</label>
        <input type="number" v-model="bedroomCount" class="form-control"><!-- TODO: Make dropdown -->
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="label-margin"><i class="fas fa-bath"></i>Baths</label>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <label for="fullBaths" class="label-margin">Full</label>
        <input type="number" v-model="fullBaths">
      </div>
      <div class="col-3">
        <label for="threeQuarterBaths" class="label-margin">3/4</label>
        <input type="number" v-model="threeQuarterBaths">
      </div>
      <div class="col-3">
        <label for="halfBaths" class="label-margin">1/2</label>
        <input type="number" v-model="halfBaths">
      </div>
      <div class="col-3">
        <label for="quarterBaths" class="label-margin">1/4</label>
        <input type="number" v-model="quarterBaths">
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label for="houseSqft" class="label-margin">Finished Square Footage</label>
        <input type="number" v-model="houseSqft">ft<sup>2</sup>
      </div>
      <div class="col-4">
        <label for="yearBuilt" class="label-margin">Year Built</label>
        <input type="number" v-model="yearBuilt">
      </div>
      <div class="col-4">
        <label for="hoaFee" class="label-margin">HOA Dues</label>
        $<input type="number" v-model="hoaFee">
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-couch"></i>Room Details</h5>
      </div>
    </div>
    <!-- TODO: Verify these are the correct names used in MLS data and the correct parameter to apply these to -->
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Bonus Room" v-model="otherRooms">
          <label class="form-check-label">Bonus Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Family Room" v-model="otherRooms">
          <label class="form-check-label">Family Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Exercise Room" v-model="otherRooms">
          <label class="form-check-label">Exercise Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Laundry" v-model="otherRooms">
          <label class="form-check-label">Laundry</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Library" v-model="otherRooms">
          <label class="form-check-label">Library</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Office" v-model="otherRooms">
          <label class="form-check-label">Office</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Den" v-model="otherRooms">
          <label class="form-check-label">Den</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Deck" v-model="otherRooms">
          <label class="form-check-label">Deck</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="4 Season Porch" v-model="otherRooms">
          <label class="form-check-label">4 Season Porch</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="3 Season Porch" v-model="otherRooms">
          <label class="form-check-label">3 Season Porch</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Patio" v-model="otherRooms">
          <label class="form-check-label">Patio</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Screened Porch" v-model="otherRooms">
          <label class="form-check-label">Screened Porch</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Pantry" v-model="otherRooms">
          <label class="form-check-label">Pantry</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Mud Room" v-model="otherRooms">
          <label class="form-check-label">Mud Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Work Shop" v-model="otherRooms">
          <label class="form-check-label">Work Shop</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Breeze Way" v-model="otherRooms">
          <label class="form-check-label">Breeze Way</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Study" v-model="otherRooms">
          <label class="form-check-label">Study</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Second Kitchen" v-model="otherRooms">
          <label class="form-check-label">Second Kitchen</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Panic Room" v-model="otherRooms">
          <label class="form-check-label">Panic Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Spa/Sauna Room" v-model="otherRooms">
          <label class="form-check-label">Spa/Sauna Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Wine Cellar" v-model="otherRooms">
          <label class="form-check-label">Wine Cellar</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Unfinished" v-model="otherRooms">
          <label class="form-check-label">Unfinished</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Sun Room" v-model="otherRooms">
          <label class="form-check-label">Sun Room</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Rec Room" v-model="otherRooms">
          <label class="form-check-label">Rec Room</label>
        </div>
      </div>
    </div>
    <!-- TODO: Ask Kate about including flooring which isn't currently an attribute of the model -->
    <div class="row">
      <div class="col">
        <h6 class="sub-header">Basement</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Walkout" v-model="basement">
          <label class="form-check-label">Walkout</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Finished" v-model="basement">
          <label class="form-check-label">Finished</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Partially Finished" v-model="basement">
          <label class="form-check-label">Partially Finished</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Full" v-model="basement">
          <label class="form-check-label">Full</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Partial" v-model="basement">
          <label class="form-check-label">Partial</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Crawl Space" v-model="basement">
          <label class="form-check-label">Crawl Space</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Unfinished" v-model="basement">
          <label class="form-check-label">Unfinished</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Sump Pump" v-model="basement">
          <label class="form-check-label">Sump Pump</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="None" v-model="basement">
          <label class="form-check-label">None</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Egress Windows" v-model="basement">
          <label class="form-check-label">Egress Windows</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Shared Access" v-model="basement">
          <label class="form-check-label">Shared Access</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="basement">
          <label class="form-check-label">Other</label>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-clipboard-list"></i>Building Amenities</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Fireplace" v-model="unitAmenities">
          <label class="form-check-label">Fireplace</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Granite Countertops" v-model="unitAmenities">
          <label class="form-check-label">Granite Countertops</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Skylight" v-model="unitAmenities">
          <label class="form-check-label">Skylight</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Ceiling Fan(s)" v-model="unitAmenities">
          <label class="form-check-label">Ceiling Fan(s)</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="unitAmenities">
          <label class="form-check-label">Other</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Kitchen Island" v-model="unitAmenities">
          <label class="form-check-label">Kitchen Island</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Natural Woodwork" v-model="unitAmenities">
          <label class="form-check-label">Natural Woodwork</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Vaulted Ceiling(s)" v-model="unitAmenities">
          <label class="form-check-label">Vaulted Ceiling(s)</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="French Doors" v-model="unitAmenities">
          <label class="form-check-label">French Doors</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Walk-In Closet" v-model="unitAmenities">
          <label class="form-check-label">Walk-In Closet</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Walk-Up Attic" v-model="unitAmenities">
          <label class="form-check-label">Walk-Up Attic</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Security System" v-model="unitAmenities">
          <label class="form-check-label">Security System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Formal Dining Room" v-model="unitAmenities">
          <label class="form-check-label">Formal Dining Room</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Wet Bar" v-model="unitAmenities">
          <label class="form-check-label">Wet Bar</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Intercom System" v-model="unitAmenities">
          <label class="form-check-label">Intercom System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Indoor Sprinklers" v-model="unitAmenities">
          <label class="form-check-label">Indoor Sprinklers</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Jetted Tub" v-model="unitAmenities">
          <label class="form-check-label">Jetted Tub</label>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-blender"></i>Appliances</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Air Conditioner" v-model="appliances">
          <label class="form-check-label">Air Conditioner</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Central Vacuum" v-model="appliances">
          <label class="form-check-label">Central Vacuum</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Cooktop" v-model="appliances">
          <label class="form-check-label">Cooktop</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Dishwasher" v-model="appliances">
          <label class="form-check-label">Dishwasher</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Disposal" v-model="appliances">
          <label class="form-check-label">Disposal</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Dryer" v-model="appliances">
          <label class="form-check-label">Dryer</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Exhaust Fan/Hood" v-model="appliances">
          <label class="form-check-label">Exhaust Fan/Hood</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Freezer" v-model="appliances">
          <label class="form-check-label">Freezer</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Fuel Tank" v-model="appliances">
          <label class="form-check-label">Fuel Tank</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Furnace" v-model="appliances">
          <label class="form-check-label">Furnace</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Furnace Humidifier" v-model="appliances">
          <label class="form-check-label">Furnace Humidifier</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Hot Tub" v-model="appliances">
          <label class="form-check-label">Hot Tub</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Iron Filter" v-model="appliances">
          <label class="form-check-label">Iron Filter</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Kegerator" v-model="appliances">
          <label class="form-check-label">Kegerator</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Microwave" v-model="appliances">
          <label class="form-check-label">Microwave</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Oven" v-model="appliances">
          <label class="form-check-label">Oven</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Radon Mitigation System" v-model="appliances">
          <label class="form-check-label">Radon Mitigation System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Range" v-model="appliances">
          <label class="form-check-label">Range</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Refrigerator" v-model="appliances">
          <label class="form-check-label">Refrigerator</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Security System" v-model="appliances">
          <label class="form-check-label">Security System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Smart Doorbell" v-model="appliances">
          <label class="form-check-label">Smart Doorbell</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Smart Thermostat" v-model="appliances">
          <label class="form-check-label">Smart Thermostat</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Sound System" v-model="appliances">
          <label class="form-check-label">Sound System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Tankless Water Heater" v-model="appliances">
          <label class="form-check-label">Tankless Water Heater</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Television" v-model="appliances">
          <label class="form-check-label">Television</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Trash Compactor" v-model="appliances">
          <label class="form-check-label">Trash Compactor</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Washer" v-model="appliances">
          <label class="form-check-label">Washer</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Water Filtration System" v-model="appliances">
          <label class="form-check-label">Water Filtration System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Water Osmosis System" v-model="appliances">
          <label class="form-check-label">Water Osmosis System</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Wine Fridge" v-model="appliances">
          <label class="form-check-label">Wine Fridge</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Water Softener" v-model="appliances">
          <label class="form-check-label">Water Softener</label>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-car"></i>Garage and Parking</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Attached Garage" v-model="garage">
          <label class="form-check-label">Attached Garage</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Tuck Under Garage" v-model="garage">
          <label class="form-check-label">Tuck Under Garage</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Underground Garage" v-model="garage">
          <label class="form-check-label">Underground Garage</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Gravel" v-model="driveway">
          <label class="form-check-label">Driveway - Gravel</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="None" v-model="garage">
          <label class="form-check-label">None</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Detached Garage" v-model="garage">
          <label class="form-check-label">Detached Garage</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Tandem Garage" v-model="garage">
          <label class="form-check-label">Tandem Garage</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Covered Parking" v-model="garage">
          <label class="form-check-label">Covered Parking</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Asphalt" v-model="driveway">
          <label class="form-check-label">Driveway - Asphalt</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="driveway">
          <label class="form-check-label">Driveway - Other</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Assigned" v-model="garage">
          <label class="form-check-label">Assigned</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="On-Street Parking Only" v-model="garage">
          <label class="form-check-label">On-Street Parking Only</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Concrete" v-model="driveway">
          <label class="form-check-label">Driveway - Concrete</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Secured" v-model="garage">
          <label class="form-check-label">Secured</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Unassigned" v-model="garage">
          <label class="form-check-label">Unassigned</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="garage">
          <label class="form-check-label">Other</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Shared" v-model="driveway">
          <label class="form-check-label">Driveway - Shared</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="garageStalls" class="label-margin">Number of Parking Spaces</label>
        <input type="number" v-model="garageStalls">
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-tree"></i>Outside and Lot Features</h5>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 class="sub-header">Exterior</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Block" v-model="exterior">
          <label class="form-check-label">Block</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Concrete" v-model="exterior">
          <label class="form-check-label">Concrete</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Steel" v-model="exterior">
          <label class="form-check-label">Steel</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Vinyl" v-model="exterior">
          <label class="form-check-label">Vinyl</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Brick/Stone" v-model="exterior">
          <label class="form-check-label">Brick/Stone</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Log" v-model="exterior">
          <label class="form-check-label">Log</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Stucco" v-model="exterior">
          <label class="form-check-label">Stucco</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Aluminum" v-model="exterior">
          <label class="form-check-label">Aluminum</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Wood" v-model="exterior">
          <label class="form-check-label">Wood</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Shakes" v-model="exterior">
          <label class="form-check-label">Shakes</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Engineered Wood" v-model="exterior">
          <label class="form-check-label">Engineered Wood</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="exterior">
          <label class="form-check-label">Other</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Cedar" v-model="exterior">
          <label class="form-check-label">Cedar</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Cement Board" v-model="exterior">
          <label class="form-check-label">Cement Board</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Fiber Board" v-model="exterior">
          <label class="form-check-label">Fiber Board</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 class="sub-header">Roof</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Shingles" v-model="roof">
          <label class="form-check-label">Shingles</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Tar/Gravel" v-model="roof">
          <label class="form-check-label">Tar/Gravel</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Composition" v-model="roof">
          <label class="form-check-label">Composition</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Slate/Tile" v-model="roof">
          <label class="form-check-label">Slate/Tile</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Shakes" v-model="roof">
          <label class="form-check-label">Shakes</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Metal" v-model="roof">
          <label class="form-check-label">Metal</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Rubber" v-model="roof">
          <label class="form-check-label">Rubber</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="roof">
          <label class="form-check-label">Other</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 class="sub-header">Fencing</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Wood" v-model="fence">
          <label class="form-check-label">Wood</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Wire" v-model="fence">
          <label class="form-check-label">Wire</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Rail" v-model="fence">
          <label class="form-check-label">Rail</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="None" v-model="fence">
          <label class="form-check-label">None</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Chainlink" v-model="fence">
          <label class="form-check-label">Chainlink</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Electric" v-model="fence">
          <label class="form-check-label">Electric</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Composite" v-model="fence">
          <label class="form-check-label">Composite</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Vinyl" v-model="fence">
          <label class="form-check-label">Vinyl</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Invisible" v-model="fence">
          <label class="form-check-label">Invisible</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Partial" v-model="fence">
          <label class="form-check-label">Partial</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Privacy" v-model="fence">
          <label class="form-check-label">Privacy</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Full" v-model="fence">
          <label class="form-check-label">Full</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="fence">
          <label class="form-check-label">Other</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 class="sub-header">View</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Cul de Sac" v-model="frontage">
          <label class="form-check-label">Cul de Sac</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Sidewalks" v-model="frontage">
          <label class="form-check-label">Sidewalks</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Street Light" v-model="frontage">
          <label class="form-check-label">Street Light</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Lake" v-model="waterfrontView">
          <label class="form-check-label">Lake</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Paved Street" v-model="frontage">
          <label class="form-check-label">Paved Street</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Unpaved Street" v-model="frontage">
          <label class="form-check-label">Unpaved Street</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Storm Sewer" v-model="frontage">
          <label class="form-check-label">Storm Sewer</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="River" v-model="waterfrontView">
          <label class="form-check-label">River</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Pond" v-model="waterfrontView">
          <label class="form-check-label">Pond</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Golf Course" v-model="lotFeatures">
          <label class="form-check-label">Golf Course</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Mountain" v-model="topography">
          <label class="form-check-label">Mountain</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="frontage">
          <label class="form-check-label">Other</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Harbor" v-model="unitAmenities">
          <label class="form-check-label">Harbor</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Dock" v-model="unitAmenities">
          <label class="form-check-label">Dock</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Park" v-model="lotFeatures">
          <label class="form-check-label">Park</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 class="sub-header">Outbuildings</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Barn" v-model="outbuildings">
          <label class="form-check-label">Barn</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Chicken Coop" v-model="outbuildings">
          <label class="form-check-label">Chicken Coop</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Gazebo" v-model="outbuildings">
          <label class="form-check-label">Gazebo</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Boat House" v-model="outbuildings">
          <label class="form-check-label">Boat House</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Dog House" v-model="outbuildings">
          <label class="form-check-label">Dog House</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Green House" v-model="outbuildings">
          <label class="form-check-label">Green House</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Hot Tub" v-model="outbuildings">
          <label class="form-check-label">Hot Tub</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Sauna" v-model="outbuildings">
          <label class="form-check-label">Sauna</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Workshop" v-model="outbuildings">
          <label class="form-check-label">Workshop</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Lean-To" v-model="outbuildings">
          <label class="form-check-label">Lean-To</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Storage Shed" v-model="outbuildings">
          <label class="form-check-label">Storage Shed</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Other" v-model="outbuildings">
          <label class="form-check-label">Other</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 class="sub-header">Amenities</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <!-- TODO: Look up if all actually apply to unit amenities -->
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Patio" v-model="unitAmenities">
          <label class="form-check-label">Patio</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Dock" v-model="unitAmenities">
          <label class="form-check-label">Dock</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Balcony" v-model="unitAmenities">
          <label class="form-check-label">Balcony</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Garden" v-model="unitAmenities">
          <label class="form-check-label">Garden</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Porch" v-model="unitAmenities">
          <label class="form-check-label">Porch</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Boat Slip" v-model="unitAmenities">
          <label class="form-check-label">Boat Slip</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Outdoor Kitchen" v-model="unitAmenities">
          <label class="form-check-label">Outdoor Kitchen</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Lawn" v-model="unitAmenities">
          <label class="form-check-label">Lawn</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Pool" v-model="unitAmenities">
          <label class="form-check-label">Pool</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Fenced Yard" v-model="unitAmenities">
          <label class="form-check-label">Fenced Yard</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Sprinkler System" v-model="unitAmenities">
          <label class="form-check-label">Sprinkler System</label>
        </div>
      </div>
      <div class="col-3">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Pond" v-model="unitAmenities">
          <label class="form-check-label">Pond</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="RV Parking" v-model="unitAmenities">
          <label class="form-check-label">RV Parking</label>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" value="Waterfront" v-model="unitAmenities">
          <label class="form-check-label">Waterfront</label>
        </div>
      </div>
    </div>
    <div class="row button-padding">
      <div class="col-4 offset-2">
        <button class="btn btn-primary" v-on:click="savePropertyDetails()">Save</button>
      </div>
      <div class="col-4">
        <button class="btn btn-secondary" v-on:click="edit = false">Close</button>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row" v-if="remarks">
      <div class="col">
        <p class="no-margin" v-on:click="fullTextShown = true">{{ propertyDetails }}<span v-if="!fullTextShown">... <span class="underline-hover">More</span></span></p>
      </div>
    </div>

    <!-- Bedrooms -->
    <div v-if="bedroomCount > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-bed"></i>Bedrooms: {{ bedroomCount }}</h5>
      </div>
    </div>
    <ul v-if="bedrooms.length > 0" class="row">
      <li class="col-6" v-for="(bedroom, index) in bedrooms" v-bind:key="index + 'bedrooms'">{{ bedroom }}</li>
    </ul>

    <!-- Bathrooms -->
    <div v-if="bathroomCount > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-bath"></i>Bathrooms: {{ bathroomCount }}</h5>
      </div>
    </div>
    <!--<div v-if="bathroomCount > 0" class="row">
      <div class="col-3">
        <ul><li>Full: {{ fullBaths }}</li></ul>
      </div>
      <div class="col-3">
        <ul><li>3/4: {{ threeQuarterBaths }}</li></ul>
      </div>
      <div class="col-3">
        <ul><li>1/2: {{ halfBaths }}</li></ul>
      </div>
      <div class="col-3">
        <ul><li>1/4: {{ quarterBaths }}</li></ul>
      </div>
    </div>-->
    <ul v-if="bathroomCount > 0" class="row">
      <li class="col-6" v-for="(bathroom, index) in bathrooms" v-bind:key="index + 'bathroom'">{{ bathroom }}</li>
    </ul>

    <!-- Kitchen and Dining -->
    <div v-if="kitchenAndDining.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-wine-glass"></i>Kitchen/Dining</h5>
      </div>
    </div>
    <ul v-if="kitchenAndDining.length > 0" class="row">
      <li class="col-6" v-for="(item, index) in kitchenAndDining" v-bind:key="index + 'knd'">{{ item }}</li>
    </ul>

    <!-- Other Rooms -->
    <div v-if="otherRoomsDisplay.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-couch"></i>Other Rooms</h5>
      </div>
    </div>
    <ul v-if="otherRoomsDisplay.length > 0" class="row">
      <li class="col-6" v-for="(room, index) in otherRoomsDisplay" v-bind:key="index + 'otherroom'">{{ room }}</li>
    </ul>

    <!-- Heating and Cooling -->
    <div v-if="Object.entries(heatingAndCooling).length !== 0 && heatingAndCooling.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-thermometer-three-quarters"></i>Heating and Cooling</h5>
      </div>
    </div>
    <ul v-if="Object.entries(heatingAndCooling).length !== 0 && heatingAndCooling.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in heatingAndCooling" v-bind:key="name + 'hnc'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- Appliances -->
    <div v-if="appliances.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-blender"></i>Appliances</h5>
      </div>
    </div>
    <ul v-if="appliances.length > 0" class="row">
      <li class="col-6" v-for="(appliance, index) in appliances" v-bind:key="index + 'appliances'">{{ appliance }}</li>
    </ul>

    <!-- Outside and Lot Features -->
    <div v-if="Object.entries(outside).length !== 0 && outside.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-tree"></i>Outside and Lot Features</h5>
      </div>
    </div>
    <ul v-if="Object.entries(outside).length !== 0 && outside.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in outside" v-bind:key="name + 'outside'">{{ name }}: {{ item }}<span v-if="name === 'Lot Size'"> ft<sup>2</sup></span></li>
    </ul>

    <!-- Garage -->
    <div v-if="Object.entries(garageDisplay).length !== 0 && garageDisplay.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-car"></i>Garage and Parking</h5>
      </div>
    </div>
    <ul v-if="Object.entries(garageDisplay).length !== 0 && garageDisplay.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in garageDisplay" v-bind:key="name + 'garage'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- Amenities and Community Features -->
    <div v-if="Object.entries(amenities).length !== 0 && amenities.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-table-tennis"></i>Amenities and Community Features</h5>
      </div>
    </div>
    <ul v-if="Object.entries(amenities).length !== 0 && amenities.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in amenities" v-bind:key="name + 'amenities'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- Basement -->
    <div v-if="basement.length > 0" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-archive"></i>Basement</h5>
      </div>
    </div>
    <ul v-if="basement.length > 0" class="row">
      <li class="col-6" v-for="(item, index) in basement" v-bind:key="index + 'basement'">{{ item }}</li>
    </ul>

    <!-- Other Property Features -->
    <div v-if="Object.entries(otherPropFeat).length !== 0 && otherPropFeat.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-clipboard-list"></i>Other Property Features</h5>
      </div>
    </div>
    <ul v-if="Object.entries(otherPropFeat).length !== 0 && otherPropFeat.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in otherPropFeat" v-bind:key="name + 'opf'">{{ name }}: {{ item }}</li>
    </ul>

    <!-- School Information -->
    <div class="row" v-if="schoolDistrict || schoolName">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-school"></i>School Information</h5>
      </div>
    </div>
    <ul v-if="schoolDistrict || schoolName">
      <li class="no-margin">School: {{ schoolDistrict + ' - ' + schoolName }}</li>
    </ul>

    <!-- Financial Information -->
    <div v-if="Object.entries(financialInformation).length !== 0 && financialInformation.constructor === Object" class="row">
      <div class="col">
        <h5 class="detail-subsection"><i class="fas fa-piggy-bank"></i>Financial Information</h5>
      </div>
    </div>
    <ul v-if="Object.entries(financialInformation).length !== 0 && financialInformation.constructor === Object" class="row">
      <li class="col-6" v-for="(item, name) in financialInformation" v-bind:key="name + 'fin'">{{ name }}: {{ item }}</li>
    </ul>
    <div class="row">
      <div class="col">
        <button class="btn btn-primary" v-on:click="edit = true">Edit Details</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from 'vue-loading-overlay'
import router from '../../../../router/index.js'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  props: {
    propertyCreation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      edit: false,
      fullTextShown: false,
      homeTypes: [
        'Townhouse',
        'Condo',
        'House',
        'Multi-Family',
        'Land'
      ],
      loading: false
    }
  },
  methods: {
    ...mapActions('property', [
      'putPropertyData'
    ]),
    ...mapActions('user', [
      'getCurrentUserData',
      'putUserData'
    ]),
    ...mapMutations('property', [
      'updateAppliances',
      'updateBasement',
      'updateBathroomCount',
      'updateBedroomCount',
      'updateCity',
      'updateCounty',
      'updateDriveway',
      'updateExterior',
      'updateFence',
      'updateFrontage',
      'updateFullBaths',
      'updateGarage',
      'updateGarageStalls',
      'updateHalfBaths',
      'updateHoaFee',
      'updateHouseSqft',
      'updateLotFeatures',
      'updateOtherRooms',
      'updateOutbuildings',
      'updateParcelId',
      'updateQuarterBaths',
      'updateRemarks',
      'updateRoof',
      'updateState',
      'updateStyle',
      'updateStreetDir',
      'updateStreetName',
      'updateStreetNumber',
      'updateStreetSuffix',
      'updateThreeQuarterBaths',
      'updateTopography',
      'updateUniqueId',
      'updateUnitAmenities',
      'updateUnitNumber',
      'updateUserEntered',
      'updateWaterfrontView',
      'updateYearBuilt',
      'updateZipCode'
    ]),
    ...mapMutations('user', [
      'addClaimedHouse'
    ]),
    async savePropertyDetails () {
      if (!this.getIdProvider) {
        this.$emit('create-property-user-not-logged-in')
        return
      }
      // if (!this.streetNumber || !this.streetName || !this.streetEnding || !this.streetDirection || !this.city || !this.state || !this.zipCode || !this.county || !this.parcelId || !this.unitNumber) alert('Some address elements were not filled out.  You will not be able to change these once you have created the record.  Are you sure you wish to proceed?') TODO: Include warning before user accepts
      this.loading = true
      if (!this.uniqueId && this.state && this.county && this.parcelId && this.unitNumber) this.updateUniqueId(this.state + ':' + this.county + ':' + this.parcelId + ':' + this.unitNumber)
      if (!this.uniqueId && this.state && this.county && this.parcelId) this.updateUniqueId(this.state + ':' + this.county + ':' + this.parcelId)
      if (!this.uniqueId) this.updateUniqueId(this.uuidv4())
      if (this.fullBaths || this.threeQuarterBaths || this.halfBaths || this.quarterBaths) {
        let full = parseInt(this.fullBaths) || 0
        let threeQuarter = parseInt(this.threeQuarterBaths) || 0
        let half = parseInt(this.halfBaths) || 0
        let quarter = parseInt(this.quarterBaths) || 0
        this.updateBathroomCount(full + threeQuarter * 0.75 + half * 0.5 + quarter * 0.25)
      }
      // Backend call
      if (this.propertyCreation) {
        this.updateUserEntered(true)
        let result = await this.putPropertyData({ uniqueId: this.uniqueId, method: 'POST' })
        if (result.status === 201) {
          await this.getCurrentUserData()
          this.addClaimedHouse(this.uniqueId)
          await this.putUserData()
        } else {
          console.log('House not claimed.')
        }
      } else {
        await this.putPropertyData({ uniqueId: this.uniqueId })
      }
      this.loading = false
      this.edit = false
      if (this.propertyCreation) router.push('/property/' + this.uniqueId)
    },
    uuidv4 () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    }
  },
  computed: {
    ...mapGetters([
      'getIdProvider'
    ]),
    ...mapGetters('property', [
      'getAgriculturalWater',
      'getAppliances',
      'getAssessmentPending',
      'getBasement',
      'getBathroomCount',
      'getBathrooms',
      'getBedrooms',
      'getBedroomCount',
      'getCity',
      'getCooling',
      'getCommunityName',
      'getCounty',
      'getDiningDescription',
      'getDiningRoom',
      'getDriveway',
      'getExterior',
      'getFence',
      'getFrontage',
      'getFireplaceCount',
      'getFireplaces',
      'getFoundationSize',
      'getFrontage',
      'getFuel',
      'getFullBaths',
      'getGarage',
      'getGarageDimensions',
      'getGarageDoorHeight',
      'getGarageDoorWidth',
      'getGarageStalls',
      'getGreenCert',
      'getHalfBaths',
      'getHandicapAccess',
      'getHeating',
      'getHoaBenefits',
      'getHoaCompanyName',
      'getHoaFee',
      'getHoaFeeFrequency',
      'getHouseSqft',
      'getKitchen',
      'getLotAcres',
      'getLotDimensions',
      'getLotFeatures',
      'getLotSqft',
      'getMlsId',
      'getNeighborhood',
      'getOtherRooms',
      'getOtherStalls',
      'getOutbuildings',
      'getParcelId',
      'getPresentUse',
      'getQuarterBaths',
      'getRemarks',
      'getRoof',
      'getSchoolDistrict',
      'getSchoolName',
      'getStreetDir',
      'getStreetName',
      'getStreetNumber',
      'getStreetSuffix',
      'getSharedAmenities',
      'getState',
      'getStyle',
      'getThreeQuarterBaths',
      'getTopography',
      'getUniqueId',
      'getUnitAmenities',
      'getUnitNumber',
      'getWater',
      'getWaterfrontName',
      'getWaterfrontView',
      'getYearBuilt',
      'getZipCode'
    ]),
    agriculturalWater () {
      return this.getAgriculturalWater
    },
    appliances: {
      get () {
        return this.getAppliances
      },
      set (value) {
        this.updateAppliances(value)
      }
    },
    assessmentPending () {
      return this.getAssessmentPending
    },
    bathrooms () {
      return this.getBathrooms
    },
    bathroomCount () {
      return this.getBathroomCount
    },
    basement: {
      get () {
        return this.getBasement
      },
      set (value) {
        this.updateBasement(value)
      }
    },
    bedrooms () {
      return this.getBedrooms
    },
    bedroomCount: {
      get () {
        return this.getBedroomCount
      },
      set (value) {
        this.updateBedroomCount(value)
      }
    },
    city: {
      get () {
        return this.getCity
      },
      set (value) {
        this.updateCity(value)
      }
    },
    communityName () {
      return this.getCommunityName
    },
    cooling () {
      return this.getCooling
    },
    county: {
      get () {
        return this.getCounty
      },
      set (value) {
        this.updateCounty(value)
      }
    },
    diningDescription () {
      return this.getDiningDescription
    },
    diningRoom () {
      return this.getDiningRoom
    },
    driveway: {
      get () {
        return this.getDriveway
      },
      set (value) {
        this.updateDriveway(value)
      }
    },
    exterior: {
      get () {
        return this.getExterior
      },
      set (value) {
        this.updateExterior(value)
      }
    },
    fence: {
      get () {
        return this.getFence
      },
      set (value) {
        this.updateFence(value)
      }
    },
    fireplaceCount () {
      return this.getFireplaceCount
    },
    fireplaces () {
      return this.getFireplaces
    },
    foundationSize () {
      return this.getFoundationSize
    },
    frontage: {
      get () {
        return this.getFrontage
      },
      set (value) {
        this.updateFrontage(value)
      }
    },
    fuel () {
      return this.getFuel
    },
    fullBaths: {
      get () {
        return this.getFullBaths
      },
      set (value) {
        this.updateFullBaths(value)
      }
    },
    garage: {
      get () {
        return this.getGarage
      },
      set (value) {
        this.updateGarage(value)
      }
    },
    garageDimensions () {
      return this.getGarageDimensions
    },
    garageDoorHeight () {
      return this.getGarageDoorHeight
    },
    garageDoorWidth () {
      return this.getGarageDoorWidth
    },
    garageStalls: {
      get () {
        return this.getGarageStalls
      },
      set (value) {
        this.updateGarageStalls(parseInt(value))
      }
    },
    greenCert () {
      return this.getGreenCert
    },
    halfBaths: {
      get () {
        return this.getHalfBaths
      },
      set (value) {
        this.updateHalfBaths(value)
      }
    },
    handicapAccess () {
      return this.getHandicapAccess
    },
    heating () {
      return this.getHeating
    },
    hoaBenefits () {
      return this.getHoaBenefits
    },
    hoaCompanyName () {
      return this.getHoaCompanyName
    },
    hoaFee: {
      get () {
        return this.getHoaFee
      },
      set (value) {
        this.updateHoaFee(value)
      }
    },
    hoaFeeFrequency () {
      return this.getHoaFeeFrequency
    },
    houseSqft: {
      get () {
        return this.getHouseSqft
      },
      set (value) {
        this.updateHouseSqft(value)
      }
    },
    kitchen () {
      return this.getKitchen
    },
    lotAcres () {
      return this.getLotAcres
    },
    lotDimensions () {
      return this.getLotDimensions
    },
    lotFeatures: {
      get () {
        return this.getLotFeatures
      },
      set (value) {
        this.updateLotFeatures(value)
      }
    },
    lotSqft () {
      return this.getLotSqft
    },
    mlsId () {
      return this.getMlsId
    },
    neighborhood () {
      return this.getNeighborhood
    },
    otherRooms: {
      get () {
        return this.getOtherRooms
      },
      set (value) {
        this.updateOtherRooms(value)
      }
    },
    otherStalls () {
      return this.getOtherStalls
    },
    outbuildings: {
      get () {
        return this.getOutbuildings
      },
      set (value) {
        this.updateOutbuildings(value)
      }
    },
    parcelId: {
      get () {
        return this.getParcelId
      },
      set (value) {
        this.updateParcelId(value)
      }
    },
    presentUse () {
      return this.getPresentUse
    },
    quarterBaths: {
      get () {
        return this.getQuarterBaths
      },
      set (value) {
        this.updateQuarterBaths(value)
      }
    },
    remarks: {
      get () {
        return this.getRemarks
      },
      set (value) {
        this.updateRemarks(value)
      }
    },
    roof: {
      get () {
        return this.getRoof
      },
      set (value) {
        this.updateRoof(value)
      }
    },
    schoolDistrict () {
      return this.getSchoolDistrict
    },
    schoolName () {
      return this.getSchoolName
    },
    sharedAmenities () {
      return this.getSharedAmenities
    },
    streetDirection: {
      get () {
        return this.getStreetDir
      },
      set (value) {
        this.updateStreetDir(value)
      }
    },
    streetName: {
      get () {
        return this.getStreetName
      },
      set (value) {
        this.updateStreetName(value)
      }
    },
    streetNumber: {
      get () {
        return this.getStreetNumber
      },
      set (value) {
        this.updateStreetNumber(value)
      }
    },
    streetSuffix: {
      get () {
        return this.getStreetSuffix
      },
      set (value) {
        this.updateStreetSuffix(value)
      }
    },
    state: {
      get () {
        return this.getState
      },
      set (value) {
        this.updateState(value)
      }
    },
    style: {
      get () {
        if (this.homeTypes.includes(this.getStyle)) {
          return this.getStyle
        }
        return ''
      },
      set (value) {
        this.updateStyle(value)
      }
    },
    threeQuarterBaths: {
      get () {
        return this.getThreeQuarterBaths
      },
      set (value) {
        this.updateThreeQuarterBaths(value)
      }
    },
    topography: {
      get () {
        return this.getTopography
      },
      set (value) {
        this.updateTopography(value)
      }
    },
    uniqueId: {
      get () {
        return this.getUniqueId
      },
      set (value) {
        this.updateUniqueId(value)
      }
    },
    unitAmenities: {
      get () {
        return this.getUnitAmenities
      },
      set (value) {
        this.updateUnitAmenities(value)
      }
    },
    unitNumber: {
      get () {
        return this.getUnitNumber
      },
      set (value) {
        this.updateUnitNumber(value)
      }
    },
    water () {
      return this.getWater
    },
    waterfrontName () {
      return this.getWaterfrontName
    },
    waterfrontView: {
      get () {
        return this.getWaterfrontView
      },
      set (value) {
        this.updateWaterfrontView(value)
      }
    },
    yearBuilt: {
      get () {
        return this.getYearBuilt
      },
      set (value) {
        this.updateYearBuilt(value)
      }
    },
    zipCode: {
      get () {
        return this.getZipCode
      },
      set (value) {
        this.updateZipCode(value)
      }
    },
    propertyDetails () {
      let limit = 300
      if (this.remarks && (this.remarks.length < limit || this.fullTextShown)) return this.remarks
      else if (this.remarks) return this.remarks.slice(0, limit)
      return ''
    },
    kitchenAndDining () {
      var knd = []
      if (this.kitchen) {
        knd.push(this.kitchen)
      }
      if (this.diningRoom) {
        knd.push(this.diningRoom)
      }
      if (this.diningDescription.length > 0) {
        knd.push('Description: ' + this.diningDescription.join(', '))
      }
      return knd
    },
    otherRoomsDisplay () {
      var otrms = []
      if (this.otherRooms.length > 0) {
        otrms = this.otherRooms
      }
      if (this.furnished === 'Furnished') {
        otrms.push('Furnished')
      }
      return otrms
    },
    heatingAndCooling () {
      var hnc = {}
      if (this.cooling.length > 0) {
        hnc['Cooling'] = this.cooling.join(', ')
      }
      if (this.heating.length > 0) {
        hnc['Heating'] = this.heating.join(', ')
      }
      if (this.fuel.length > 0) {
        hnc['Fuel'] = this.fuel.join(', ')
      }
      if (this.fireplaceCount > 0) {
        hnc['# of Fireplaces'] = this.fireplaceCount
      }
      if (this.fireplaces.length > 0) {
        hnc['Fireplace Description'] = this.fireplaces.join(', ')
      }
      return hnc
    },
    outside () {
      var outside = {}
      if (this.exterior.length > 0) {
        outside['Exterior'] = this.exterior.join(', ')
      }
      if (this.fence.length > 0) {
        outside['Fencing'] = this.fence.join(', ')
      }
      if (this.outbuildings.length > 0) {
        outside['Outbuildings'] = this.outbuildings.join(', ')
      }
      if (this.lotAcres) {
        outside['Lot Size Acres'] = this.lotAcres
      }
      if (this.lotSqft) {
        outside['Lot Size'] = this.lotSqft
      }
      if (this.presentUse) {
        outside['Present Use'] = this.presentUse
      }
      if (this.frontage.length > 0) {
        outside['Frontage'] = this.frontage.join(', ')
      }
      if (this.lotDimensions) {
        outside['Lot Dimensions'] = this.lotDimensions
      }
      if (this.communityName) {
        outside['Community Name'] = this.communityName
      }
      if (this.waterfrontView.length > 0) {
        outside['Waterfront View'] = this.waterfrontView.join(', ')
      }
      if (this.waterfrontName) {
        outside['Waterfront Name'] = this.waterfrontName
      }
      if (this.lotFeatures.length > 0) {
        outside['Lot Description'] = this.lotFeatures.join(', ')
      }
      if (this.agriculturalWater.length > 0) {
        outside['Agricultural Water'] = this.agriculturalWater.join(', ')
      }
      return outside
    },
    garageDisplay () {
      var garage = {}
      if (this.garage.length > 0) {
        garage['Garage'] = this.garage.join(', ')
      }
      if (this.garageStalls) {
        garage['Garage Stalls'] = this.garageStalls
      }
      if (this.otherStalls) {
        garage['Other Stalls'] = this.otherStalls
      }
      if (this.garageDimensions) {
        garage['Garage Dimensions'] = this.garageDimensions
      }
      if (this.garageDoorHeight) {
        garage['Garage Door Height'] = this.garageDoorHeight
      }
      if (this.garageDoorWidth) {
        garage['Garage Door Width'] = this.garageDoorWidth
      }
      return garage
    },
    amenities () {
      var amenities = {}
      if (this.unitAmenities.length > 0) {
        amenities['Unit Amenities'] = this.unitAmenities.join(', ')
      }
      if (this.sharedAmenities.length > 0) {
        amenities['Shared Amenities'] = this.sharedAmenities.join(', ')
      }
      return amenities
    },
    otherPropFeat () {
      var opf = {}
      if (this.foundationSize) {
        opf['Foundation Size'] = this.foundationSize
      }
      if (this.roof.length > 0) {
        opf['Roof'] = this.roof.join(', ')
      }
      if (this.style) {
        opf['Style'] = this.style
      }
      if (this.mlsId) {
        opf['MLS ID'] = this.mlsId
      }
      if (this.parcelId.length > 0) {
        opf['Parcel Number'] = this.parcelId.join(', ')
      }
      if (this.water.length > 0) {
        opf['Water'] = this.water.join(', ')
      }
      if (this.county) {
        opf['County'] = this.county
      }
      if (this.neighborhood) {
        opf['Neighborhood'] = this.neighborhood
      }
      if (this.handicapAccess.length > 0) {
        opf['Handicap Access'] = this.handicapAccess.join(', ')
      }
      if (this.greenCert) {
        opf['Green Certified'] = this.greenCert
      }
      return opf
    },
    financialInformation () {
      var fin = {}
      if (this.assessmentPending) {
        fin['Assessment Pending'] = this.assessmentPending
      }
      if (this.hoaFee) {
        fin['HOA Fee'] = '$' + this.hoaFee
      }
      if (this.hoaFeeFrequency) {
        fin['HOA Fee Frequency'] = this.hoaFeeFrequency
      }
      if (this.hoaCompanyName) {
        fin['HOA Company Name'] = this.hoaCompanyName
      }
      if (this.hoaBenefits.length > 0) {
        fin['HOA Benefits'] = this.hoaBenefits.join(', ')
      }
      return fin
    }
  },
  watch: {
    propertyDetails: function (newValue) {
      if (this.remarks && newValue.length === this.remarks.length) this.fullTextShown = true
    }
  }
}
</script>

<style scoped>
.label-margin {
  margin-bottom: 0;
  margin-top: 0.5rem;
}

.btn-secondary {
  width: 100%;
}

.button-padding {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.letter {
  float: left;
  width: 40px;
  font-size: 25px;
  font-family: 'Black Ops One', cursive !important;
}

.fas {
  width: 40px;
  font-size: 25px;
}

.detail-subsection {
  margin-top: 1rem;
}

.no-margin {
  margin: 0;
}

.sub-header {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.underline-hover:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/UserPropertyDetails.vue